(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  ready(() => {
    document.querySelectorAll('[data-glam-sticky-atc]').forEach((bar) => {
      const sectionId = bar.dataset.sectionId;
      const section = document.querySelector(`#MainProduct-${sectionId}`) || document.querySelector('.product');
      const submit = section?.querySelector('.product-form__submit');
      const stickyButton = bar.querySelector('[data-glam-sticky-button]');
      if (!section || !submit || !stickyButton) return;

      const updateState = () => {
        stickyButton.disabled = submit.disabled;
        stickyButton.textContent = submit.querySelector('span')?.textContent?.trim() || submit.textContent.trim();
        const price = section.querySelector('.price');
        const targetPrice = bar.querySelector('[data-glam-sticky-price]');
        if (price && targetPrice) targetPrice.textContent = price.textContent.replace(/\s+/g, ' ').trim();
      };

      stickyButton.addEventListener('click', () => submit.click());
      new MutationObserver(updateState).observe(section, { childList: true, subtree: true, characterData: true, attributes: true });
      updateState();

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, { threshold: 0 });
        observer.observe(submit);
      }
    });

    document.querySelectorAll('[data-glam-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-glam-carousel-track]');
      const section = carousel.closest('.glam-reviews');
      const previous = section?.querySelector('[data-glam-carousel-prev]');
      const next = section?.querySelector('[data-glam-carousel-next]');
      if (!track || !previous || !next) return;

      const stepSize = () => {
        const slide = track.querySelector('.glam-carousel__slide');
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return (slide?.getBoundingClientRect().width || track.clientWidth) + gap;
      };

      const move = (direction) => {
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        const atStart = track.scrollLeft <= 8;
        if (direction > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (direction < 0 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: stepSize() * direction, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));

      const shouldAutoplay = carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!shouldAutoplay || track.children.length < 2) return;

      const speed = Number(carousel.dataset.speed) || 5000;
      let timer;
      const start = () => {
        window.clearInterval(timer);
        timer = window.setInterval(() => move(1), speed);
      };
      const stop = () => window.clearInterval(timer);

      carousel.addEventListener('pointerenter', stop);
      carousel.addEventListener('pointerleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      start();
    });
  });
})();
